import { Box, Button, InputAdornment, OutlinedInput, Paper, SxProps, Theme } from "@mui/material";
import useInventoryTemplates from "../hooks/useInventoryTemplates";
import { InventoryTemplate } from "types/inventoryTemplate";
import InventoryTemplatesDataGrid from "components/InventoryTemplates/InventoryTemplatesDataGrid";
import InventoryTemplateForm from "components/InventoryTemplates/InventoryTemplateForm";
import { debounce } from "lodash";
import useServerSideDataGridParams from "hooks/useServerSideDataGridParams";
import { Add, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { PageActions, PageBreadcrumbs, PageTitle } from "./Layouts/components/PageTitleContainer";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";

type InventoryTemplatesProps = {
  sx?: SxProps<Theme>;
  onClose?: (inventoryTemplate: InventoryTemplate) => void;
};

export default function InventoryTemplatesPage({ sx }: InventoryTemplatesProps) {
  const newTemplate: InventoryTemplate = {
    uuid: "",
    manufacturer: "",
    model: "",
    name: "",
    description: "",
    cpu: "",
    ram: "",
    hardDrive: "",
    screenSize: "",
    isBulk: false,
    deviceType: "",
  };

  const {
    inventoryTemplates,
    inventoryTemplate,
    editInventoryTemplate,
    deleteInventoryTemplate,
    createInventoryTemplate,
    meta,
    setInventoryTemplate,
  } = useInventoryTemplates();
  const pageState = useServerSideDataGridParams(inventoryTemplates);
  const { setSearchQuery } = pageState;

  const navigate = useNavigate();

  return (
    <AutoPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Warehouse" }]} />
      <PageTitle>Inventory Templates</PageTitle>
      <PageActions>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            navigate(`/inventory-templates`);
            setInventoryTemplate(undefined);
          }}
        >
          Add new template
        </Button>
      </PageActions>
      <Box sx={{ padding: 3 }}>
        <OutlinedInput
          size="small"
          fullWidth
          onChange={debounce((e) => setSearchQuery(e.target.value), 300)}
          placeholder="Search"
          startAdornment={
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          }
        />
      </Box>
      <InventoryTemplatesDataGrid
        inventoryTemplates={inventoryTemplates}
        handleDelete={deleteInventoryTemplate}
        pageState={pageState}
        meta={meta}
      />

      <InventoryTemplateForm
        createInventoryTemplate={createInventoryTemplate}
        editInventoryTemplate={editInventoryTemplate}
        defaultValues={inventoryTemplate || newTemplate}
      />
    </AutoPagePaperLayout>
  );
}
